import appConstants from '@appConstants';
import { RMAXLogger } from '@RMAXLogger';
import { isCityRoute } from '../../modules/IBPlanning/RoutesView/utils';

export const STALE_KPI_REQUEST_ERROR = 'Stale request. Cancelled';
export const PREFERRED_ROUTE_WARNING_DIALOG = 'PreferredRouteWarning';

/** Datadog actions — filter on `EnforcedDR:`. */
export const logEnforcedDR = (
  event: string,
  context: Record<string, unknown> = {}
): void => {
  RMAXLogger.addAction(`EnforcedDR: ${event}`, context);
};

type RouteLike = {
  routeName?: string;
  isTrapRoute?: boolean;
  status?: number;
};

export type IBKPIsResponse = {
  status?: number;
  data?: {
    ibKpi?: unknown;
    isFirstOptimizationRun?: boolean;
  };
};

type AutoOpenArgs = {
  isFeatureEnabled?: boolean;
  isFirstOptimizationRun?: boolean;
  cityRouteNames?: string[];
  isDialogOpen?: boolean;
  isDynamicRoutingCompleted?: boolean;
  isCustomerOverlayOpen?: boolean;
};

export const isUnlockedCityRoute = (route: RouteLike): boolean =>
  isCityRoute(route) && route.status !== appConstants.routeLockStates.LOCK.value;

export const filterCityRouteNamesForEnforcedDR = (
  cityRouteNames: Array<string | null | undefined> = []
): string[] =>
  cityRouteNames.filter(
    (routeName): routeName is string =>
      Boolean(routeName) && routeName !== appConstants.LINKEX_ROUTE_NAME
  );

export const getCityRouteNamesFromRoutesList = (routesList: RouteLike[] = []): string[] =>
  filterCityRouteNamesForEnforcedDR(
    routesList.filter((route) => isUnlockedCityRoute(route)).map((route) => route.routeName)
  );

export const parseIBKPIsResponse = (response?: IBKPIsResponse | null) => {
  if (!response || response.status !== 200) {
    return { ok: false, ibKpi: [] as unknown[], isFirstOptimizationRun: false };
  }
  const ibKpi = Array.isArray(response.data?.ibKpi) ? response.data.ibKpi : [];
  return {
    ok: true,
    ibKpi,
    isFirstOptimizationRun: Boolean(response.data?.isFirstOptimizationRun)
  };
};

export const isStaleKpiRequestError = (error: unknown): boolean =>
  error === STALE_KPI_REQUEST_ERROR;

// Customer Management is opened with ?customerCode=. Do not auto-open Dynamic Routing on top of it.
export const hasCustomerOverlayOpen = (search = ''): boolean =>
  Boolean(new URLSearchParams(search).get('customerCode'));

export const shouldAutoOpenEnforcedDynamicRouting = ({
  isFeatureEnabled,
  isFirstOptimizationRun,
  cityRouteNames,
  isDialogOpen,
  isDynamicRoutingCompleted,
  isCustomerOverlayOpen
}: AutoOpenArgs): boolean => {
  return Boolean(
    isFeatureEnabled &&
      isFirstOptimizationRun &&
      cityRouteNames?.length &&
      !isDialogOpen &&
      !isDynamicRoutingCompleted &&
      !isCustomerOverlayOpen
  );
};
